import React, { Fragment, useEffect, useState, useRef } from "react";
import { useSnackBar } from "../../../../hooks/useSnackBar";
import DiscussionBody from "../DiscussionBody/DiscussionBody";
import {
  MdOutlineWifiCalling3,
  MdOutlineMailOutline,
  MdClose,
} from "react-icons/md";
import { useSelector } from "react-redux";
import {
  deleteTicketMedia,
  closeTicketService,
  updateTicketStatusService,
  getTicketMediaService,
  getTicketDetailsService,
} from "../../../../services/Tickets/ticket.service";
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { convertTime } from "../../../../helpers/helpers";
import { useTranslation } from "react-i18next";

const DiscussionSkeleton = () => (
  <div className="flex w-full items-stretch gap-5">
    {/* Chat column */}
    <div className="flex w-full flex-col gap-5 rounded-lg border border-ui-border bg-ui-surface p-4">
      <div className="flex items-start gap-3 border-b border-ui-border pb-4">
        <div className="h-10 w-10 shrink-0 animate-pulse rounded-full bg-ui-border" />
        <div className="flex-1 space-y-2">
          <div className="h-3.5 w-40 animate-pulse rounded bg-ui-border" />
          <div className="h-3 w-52 animate-pulse rounded bg-ui-border" />
        </div>
        <div className="h-3 w-20 shrink-0 animate-pulse rounded bg-ui-border" />
      </div>
      <div className="flex min-h-[57vh] flex-col justify-between gap-4">
        <div className="flex flex-col gap-4">
          <div className="h-14 w-2/3 animate-pulse rounded-xl bg-ui-border" />
          <div className="ml-auto h-10 w-1/2 animate-pulse rounded-xl bg-ui-border" />
          <div className="h-16 w-3/5 animate-pulse rounded-xl bg-ui-border" />
          <div className="ml-auto h-12 w-2/5 animate-pulse rounded-xl bg-ui-border" />
          <div className="h-10 w-1/2 animate-pulse rounded-xl bg-ui-border" />
          <div className="ml-auto h-14 w-3/5 animate-pulse rounded-xl bg-ui-border" />
        </div>
        <div className="h-11 w-full animate-pulse rounded-lg bg-ui-border" />
      </div>
    </div>

    {/* Ticket details column */}
    <div className="flex w-full max-w-[325px] shrink-0 flex-col gap-5 rounded-lg border border-ui-border bg-ui-surface p-4">
      <div className="h-3.5 w-28 animate-pulse rounded bg-ui-border" />
      <div className="space-y-3.5">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="flex items-center justify-between">
            <div className="h-3 w-24 animate-pulse rounded bg-ui-border" />
            <div className="h-3 w-16 animate-pulse rounded bg-ui-border" />
          </div>
        ))}
      </div>
      <div className="h-3 w-32 animate-pulse rounded bg-ui-border" />
      <div className="grid grid-cols-4 gap-2">
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            key={i}
            className="aspect-square animate-pulse rounded-lg bg-ui-border"
          />
        ))}
      </div>
      <div className="flex-1" />
    </div>
  </div>
);

const DiscussionTickets = ({
  ticketId,
  parentLoading,
  setParentLoading,
}) => {
  const { t } = useTranslation("tickets");
  const [open, setOpen] = useState(false);
  const setSnack = useSnackBar();
  const [change, setChange] = useState(false);
  const [ticketStatus, setTicketStatus] = useState("");
  const [ticketInfo, setTicketInfo] = useState("order");
  const [shipmentMedia, setShipmentMedia] = useState({});
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [imggloading, setImggLoading] = useState(false);
  const [shipperfiles, setShipperfiles] = useState("all");
  const [isMedia, setIsMedia] = useState(false);
  const [ticketResponses, setTicketResponses] = useState([]);
  const [secondsAgo, setSecondsAgo] = useState(0);
  const user = useSelector((state) => state.user);

  //creating a reference object
  const ticketIdRef = useRef(ticketId);
  ticketIdRef.current = ticketId;

  // change ticket status
  const changeTicketStatus = (e) => {
    setTicketStatus(e.target.value);
    setChange(true);
  };

  // check if media is added in child componet to update latest media
  const checkMediaAdded = (data) => {
    setIsMedia(data);
    if (data === true) {
      getTicketMedia(ticketId);
    }
  };

  // close ticket
  const closeTicket = async () => {
    setLoading(true);

    try {
      const response = await closeTicketService(ticketId);
      if (response?.data?.success === true) {
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: `${response?.data?.message}`,
            severity: "success",
          };
        });
      }

      setLoading(false);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  //update status api
  const updateTicketStatus = async () => {
    const formData = new FormData();
    formData.append("status", ticketStatus);
    setLoading(true);
    try {
      const response = await updateTicketStatusService(ticketId, formData);
      if (response?.data?.success === true) {
        setChange(false);
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: `${response?.data?.message}`,
            severity: "success",
          };
        });
      }
      setLoading(false);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // delete media
  const deleteMediaTicket = async (mediaId) => {
    setImggLoading(true);

    try {
      const response = await deleteTicketMedia(mediaId);
      if (response?.data?.success === true) {
        getTicketMedia(ticketId);
        setImggLoading(false);
        setIsMedia(true);
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: `${response?.data?.message}`,
            severity: "success",
          };
        });
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // Media api call
  const getTicketMedia = async (ticketId) => {
    try {
      const response = await getTicketMediaService(ticketId);
      if (response?.data?.success === true) {
        setShipmentMedia(response?.data?.result?.files_and_images);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getTicketDetails = async (isReloadResponses = false) => {
    try {
      if (isReloadResponses == false) setTicketResponses([]); // empty only if the ticket gets changed

      if (ticketId != null && ticketId != "undefined") {
        const response = await getTicketDetailsService(ticketId);
        if (response?.data?.success === true) {
          setParentLoading(false);
          if (isReloadResponses == false) getTicketMedia(ticketId);
          setTickets(response.data.result.ticket);
          setTicketStatus(response.data.result.ticket?.status);
          setTicketResponses(response.data.result.ticket.ticket_responses);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getTicketResponses = async (ticket_id) => {
    try {
      if (
        ticket_id != null &&
        ticket_id != "undefined" &&
        ticket_id != "" &&
        ticket_id > 0
      ) {
        const response = await getTicketDetailsService(ticket_id);
        if (response?.data?.success === true) {
          setTicketResponses(response.data.result.ticket.ticket_responses);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (ticketId != null && ticketId != "") getTicketDetails();
  }, [ticketId]);

  const MINUTE_MS = 15000;
  useEffect(() => {
    const interval = setInterval(() => {
      getTicketResponses(ticketIdRef.current);
    }, MINUTE_MS);

    return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
  }, []);

  return (
    <div className="disussion_shipping_details_container">
      {(loading || parentLoading) && <DiscussionSkeleton />}
      {!(loading || parentLoading) && tickets?.status && (
        <>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            // onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={open}>
              <div className="invoices__modal_wrapper">
                <div className="allTickets__shipment_modal">
                  <div className="allTickets__shipment_modal_header">
                    <button onClick={() => setOpen(false)}>
                      <MdClose />
                    </button>
                  </div>
                  <div className="allTickets__shipment_modal_body">
                    <div className="company-info">
                      <img
                        src={
                          tickets?.shipment?.shipping_company?.shipping_company
                            ?.logo_url
                        }
                        alt=""
                      />
                      <span className="name">
                        {
                          tickets?.shipment?.shipping_company?.shipping_company
                            ?.name
                        }
                      </span>
                    </div>
                    <div className="data">
                      <div className="data-item">
                        <span className="title">
                          {t("shipment.trackingId")}
                        </span>
                        <span className="value">
                          {tickets?.shipment?.tracking_id}
                        </span>
                      </div>

                      <div className="data-item">
                        <span className="title">
                          {t("shipment.shipmentTrackingId")}
                        </span>
                        <span className="value">
                          {tickets?.shipment?.shipment_tracking_id}
                        </span>
                      </div>
                      <div className="data-item">
                        <span className="title">{t("shipment.status")}</span>
                        <span className="value">
                          {tickets?.shipment?.shipment_status}
                        </span>
                      </div>
                      <div className="data-item">
                        <span className="title">{t("shipment.unit")}</span>
                        <span className="value">{tickets?.shipment?.unit}</span>
                      </div>
                      <div className="data-item">
                        <span className="title">
                          {t("shipment.packageType")}
                        </span>
                        <span className="value">
                          {tickets?.shipment?.package_type}
                        </span>
                      </div>
                      <div className="data-item">
                        <span className="title">
                          {t("shipment.packageVolume")}
                        </span>
                        <span className="value">
                          {tickets?.shipment?.volume}
                        </span>
                      </div>
                      <div className="data-item">
                        <span className="title">
                          {t("shipment.packageWeight")}
                        </span>
                        <span className="value">
                          {tickets?.shipment?.total_weight} lb
                        </span>
                      </div>
                      <div className="data-item">
                        <span className="title">
                          {t("shipment.serviceType")}
                        </span>
                        <span className="value">
                          {tickets?.shipment?.service_type}
                        </span>
                      </div>

                      <div className="data-item">
                        <span className="title">{t("shipment.readyOpen")}</span>
                        <span className="value">
                          {tickets?.shipment?.readyopentime}
                        </span>
                      </div>
                      <div className="data-item">
                        <span className="title">
                          {t("shipment.readyClose")}
                        </span>
                        <span className="value">
                          {tickets?.shipment?.readyclosetime}
                        </span>
                      </div>
                      <div className="data-item">
                        <span className="title">
                          {t("shipment.deliveryOpen")}
                        </span>
                        <span className="value">
                          {tickets?.shipment?.deliveryopentime}
                        </span>
                      </div>
                      <div className="data-item">
                        <span className="title">
                          {t("shipment.deliveryDate")}
                        </span>
                        <span className="value">
                          {tickets?.shipment?.deliverydate}
                        </span>
                      </div>
                      <div className="data-item">
                        <span className="title">{t("shipment.shipDate")}</span>
                        <span className="value">
                          {tickets?.shipment?.shipdate}
                        </span>
                      </div>
                      <div className="data-item">
                        <span className="title">
                          {t("shipment.pickupDate")}
                        </span>
                        <span className="value">
                          {tickets?.shipment?.PickupDate}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Fade>
          </Modal>
          <div className="disussion_main_wrap">
            <div className="disussion__main__header">
              <div className="disussion__main__header_left_col">
                <div className="disussion__header_left_title">
                  {tickets?.user?.firstname} {tickets?.user?.lastname}
                  <span>({tickets?.user?.role}) </span>
                </div>
                <div className="disussion__header_left_Id">
                  {t("discussion.id", { no: tickets?.ticket_no })}
                </div>
                <div className="disussion__header_left_subject">
                  {tickets?.description}
                </div>
              </div>
              <div className="disussion__main__header_right_col">
                <div className="disussion__header_right_contact">
                  <div className="disussion__header_right_email">
                    {tickets?.user?.email && (
                      <>
                        <MdOutlineMailOutline size={20} />{" "}
                        <span>{tickets?.user?.email}</span>
                      </>
                    )}
                  </div>
                  <div className="disussion__header_right_phone">
                    {tickets?.user?.phone_number && (
                      <>
                        <MdOutlineWifiCalling3 size={20} />{" "}
                        <span>{tickets?.user?.phone_number}</span>
                      </>
                    )}
                  </div>
                </div>

                <div className="disussion__header_right__stautses">
                  <div>
                    <select
                      name=""
                      id=""
                      value={ticketStatus}
                      onChange={changeTicketStatus}
                    >
                      <option value="Open">
                        {t("discussion.statuses.open")}
                      </option>
                      <option value="Resolved">
                        {t("discussion.statuses.resolved")}
                      </option>
                      <option value="Disputed">
                        {t("discussion.statuses.disputed")}
                      </option>
                      <option value="Closed">
                        {t("discussion.statuses.closed")}
                      </option>
                    </select>
                  </div>
                  {change && (
                    <button onClick={() => updateTicketStatus()}>
                      {t("discussion.change")}
                    </button>
                  )}
                </div>

                <div className="disussion__header_right_actions">
                  <button onClick={() => setOpen((pre) => !pre)}>
                    {t("discussion.viewShipment")}
                  </button>
                  {tickets?.status !== "Closed" && (
                    <button
                      className="close_ticket"
                      onClick={() => closeTicket()}
                    >
                      {t("discussion.closeTicket")}
                    </button>
                  )}
                </div>
              </div>
            </div>
            <div className="disussion__main__body">
              <DiscussionBody
                ticketId={ticketId}
                checkMediaAdded={checkMediaAdded}
                ticketResponses={ticketResponses}
                setTicketResponses={setTicketResponses}
              />
            </div>
          </div>
          <div className="disussionShipping__details_main_wrap">
            <h2 className="disussionShipping__details_heading">
              {t("details.title")}
            </h2>
            <ul className="disussionShipping__details_tab">
              <li
                onClick={() => setTicketInfo("order")}
                className={ticketInfo === "order" ? "active" : ""}
              >
                {t("details.order")}
              </li>
              <li
                onClick={() => setTicketInfo("billing")}
                className={ticketInfo === "billing" ? "active" : ""}
              >
                {t("details.billing")}
              </li>
            </ul>
            {ticketInfo === "order" && (
              <div className="disussionShipping__details_order_details">
                <div className="disussionShipping__details_tickenum">
                  <span className="disussionShipping__details_label">
                    {t("details.ticketNo")}
                  </span>
                  <span className="disussionShipping__details_data">
                    {tickets?.ticket_no}
                  </span>
                </div>
                <div className="disussionShipping__details_shippingId">
                  <span className="disussionShipping__details_label">
                    {t("details.shipmentId")}
                  </span>
                  <span className="disussionShipping__details_data">
                    {tickets?.shipment_id}
                  </span>
                </div>
                <div className="disussionShipping__details_order_status">
                  <span className="disussionShipping__details_label">
                    {t("details.orderStatus")}
                  </span>
                  <span className="disussionShipping__details_data">
                    {tickets?.shipment?.shipment_status}
                  </span>
                </div>
                <div className="disussionShipping__details_orderplaced">
                  <span className="disussionShipping__details_label">
                    {t("details.orderPlaced")}
                  </span>
                  <span className="disussionShipping__details_data">
                    {tickets?.shipment?.shipdate}
                  </span>
                </div>
                <div className="disussionShipping__details_master_tracking">
                  <span className="disussionShipping__details_label">
                    {t("details.masterTracking")}
                  </span>
                  <span className="disussionShipping__details_data">
                    {tickets?.shipment?.tracking_id}
                  </span>
                </div>
                <div className="disussionShipping__details_carrier_racking">
                  <span className="disussionShipping__details_label">
                    {t("details.carrierTracking")}
                  </span>
                  <span className="disussionShipping__details_data">
                    {tickets?.shipment?.shipment_id}
                  </span>
                </div>
              </div>
            )}
            {ticketInfo === "billing" && (
              <div className="disussionShipping__details_billing_details_wrapper">
                {tickets?.shipment?.shipment_charges?.length > 0 &&
                  tickets?.shipment?.shipment_charges?.map((charges) => (
                    <div
                      className="disussionShipping__details_billing_details"
                      key={charges?.id}
                    >
                      <div className="shipment_charges_header">
                        {t("details.chargesHeader", {
                          id: charges?.shipment_id,
                        })}
                      </div>
                      <div className="shimpent_charges_data">
                        <span className="title">
                          {t("details.charges.basePrice")}
                        </span>
                        <span className="value">{charges?.base_price}</span>
                      </div>
                      <div className="shimpent_charges_data">
                        <span className="title">
                          {t("details.charges.fuel")}
                        </span>
                        <span className="value">{charges?.fuel_charge}</span>
                      </div>
                      <div className="shimpent_charges_data">
                        <span className="title">
                          {t("details.charges.pickup")}
                        </span>
                        <span className="value">{charges?.PickupCharge}</span>
                      </div>
                      <div className="shimpent_charges_data">
                        <span className="title">
                          {t("details.charges.residential")}
                        </span>
                        <span className="value">
                          {charges?.residential_charge}
                        </span>
                      </div>
                      <div className="shimpent_charges_data">
                        <span className="title">
                          {t("details.charges.signature")}
                        </span>
                        <span className="value">
                          {charges?.signature_charge}
                        </span>
                      </div>
                      <div className="shimpent_charges_data">
                        <span className="title">
                          {t("details.charges.additional")}
                        </span>
                        <span className="value">
                          {charges?.additional_price}
                        </span>
                      </div>
                      <div className="shimpent_charges_data">
                        <span className="title">
                          {t("details.charges.transportation")}
                        </span>
                        <span className="value">
                          {charges?.transportation_charge}
                        </span>
                      </div>
                      <div className="shimpent_charges_data">
                        <span className="title">
                          {t("details.charges.seasonal")}
                        </span>
                        <span className="value">
                          {charges?.commercial_seasonal_surcharge}
                        </span>
                      </div>
                      <div className="shimpent_charges_data">
                        <span className="title">
                          {t("details.charges.freight")}
                        </span>
                        <span className="value">{charges?.freight_charge}</span>
                      </div>

                      {charges?.total_updated_charges?.tax_charges?.length >
                        0 && (
                        <div className="shimpent_charges_text_charges">
                          <span className="title_main">
                            {t("details.charges.totalTax")}
                          </span>
                          {charges?.total_updated_charges?.tax_charges?.map(
                            (tax) => (
                              <div
                                className="shimpent_charges_data"
                                key={tax?.id}
                              >
                                <span className="title">{tax?.NameEn}</span>
                                <span className="value">{tax?.Charge}</span>
                              </div>
                            )
                          )}
                        </div>
                      )}

                      <hr />
                      <div className="shimpent_charges_data">
                        <span className="title">
                          {t("details.charges.total")}
                        </span>
                        <span className="value">{charges?.total}</span>
                      </div>
                    </div>
                  ))}
              </div>
            )}
            <div className="disussionShipping__package_details table-responsive">
              <table className="table-borderless">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>{t("details.table.description")}</th>
                    <th>{t("details.table.barcode")}</th>
                    <th>{t("details.table.size")}</th>
                    <th>{t("details.table.weight")}</th>
                    <th>{t("details.table.dateTime")}</th>
                  </tr>
                </thead>
                <tbody>
                  {tickets?.shipment?.shipment_details?.length > 0 &&
                    tickets?.shipment?.shipment_details?.map(
                      (shipment, index) => (
                        <tr key={shipment?.id}>
                          <td>
                            <span className="count">{index + 1}</span>
                          </td>
                          <td>{shipment?.description?.slice(0, 11)}</td>
                          <td>
                            {shipment?.barcode !== null
                              ? shipment?.barcode
                              : t("details.notAvailable")}
                          </td>
                          <td>
                            {shipment?.height} * {shipment?.width} *{" "}
                            {shipment?.length}{" "}
                          </td>
                          <td>
                            {shipment?.weight
                              ? `${shipment?.weight}lb`
                              : t("details.notAvailable")}
                          </td>
                          <td>
                            <div className="icon-wrapper">
                              <span>{convertTime(shipment?.created_at)}</span>
                            </div>
                          </td>
                        </tr>
                      )
                    )}
                </tbody>
              </table>
            </div>
            <div className="disussionShipping__package_files_wrapper">
              {imggloading && (
                <div className="grid grid-cols-4 gap-2 py-2">
                  {Array.from({ length: 4 }).map((_, i) => (
                    <div
                      key={i}
                      className="aspect-square animate-pulse rounded-lg bg-ui-border"
                    />
                  ))}
                </div>
              )}
              <h2 className="title">{t("details.filesFrom")}</h2>
              <ul className="disussionShipping__package_type">
                <li
                  onClick={() => setShipperfiles("all")}
                  className={shipperfiles === "all" ? "active" : ""}
                >
                  {t("details.files.all")}
                </li>
                <li
                  onClick={() => setShipperfiles("shipper")}
                  className={shipperfiles === "shipper" ? "active" : ""}
                >
                  {t("details.files.shipper")}
                </li>
                <li
                  onClick={() => setShipperfiles("recipient")}
                  className={shipperfiles === "recipient" ? "active" : ""}
                >
                  {t("details.files.recipient")}
                </li>
                <li
                  onClick={() => setShipperfiles("carrier")}
                  className={shipperfiles === "carrier" ? "active" : ""}
                >
                  {t("details.files.carrier")}
                </li>
                <li
                  onClick={() => setShipperfiles("admin")}
                  className={shipperfiles === "admin" ? "active" : ""}
                >
                  {t("details.files.admin")}
                </li>
              </ul>
              {shipperfiles === "all" && shipmentMedia?.all?.length > 0 && (
                <div className="disussionShipping__package_files">
                  {shipmentMedia?.all?.map((media) => (
                    <Fragment key={media?.id}>
                      {media?.response_body !== null && (
                        <div className="disussionShipping__package_file_holder">
                          {media?.response_type === "image" ? (
                            <div className="image_wrapper">
                              {(media?.response_by === user?.id ||
                                user?.role === "Admin") && (
                                <div
                                  className="icon"
                                  onClick={() => deleteMediaTicket(media?.id)}
                                >
                                  <MdClose />
                                </div>
                              )}
                              <img src={media?.response_body?.file_url} />
                              <span className="name">
                                {media?.response_body?.file_name.slice(0, 10)}
                              </span>
                            </div>
                          ) : (
                            <div className="file_wrapper">
                              {(media?.response_by === user?.id ||
                                user?.role === "Admin") && (
                                <div
                                  className="icon"
                                  onClick={() => deleteMediaTicket(media?.id)}
                                >
                                  <MdClose />
                                </div>
                              )}
                              <a
                                href={media?.response_body?.file_url}
                                target="_"
                              >
                                {media?.response_body?.file_name.slice(0, 9)}
                              </a>
                            </div>
                          )}
                        </div>
                      )}
                    </Fragment>
                  ))}
                </div>
              )}

              {shipperfiles === "shipper" &&
                shipmentMedia?.shipper?.length > 0 && (
                  <div className="disussionShipping__package_files">
                    {shipmentMedia?.shipper?.map((media) => (
                      <Fragment key={media?.id}>
                        {media?.response_body !== null && (
                          <div className="disussionShipping__package_file_holder">
                            {media?.response_type === "image" ? (
                              <div className="image_wrapper">
                                {(media?.response_by === user?.id ||
                                  user?.role === "Admin") && (
                                  <div
                                    className="icon"
                                    onClick={() => deleteMediaTicket(media?.id)}
                                  >
                                    <MdClose />
                                  </div>
                                )}
                                <img src={media?.response_body?.file_url} />
                                <span className="name">
                                  {media?.response_body?.file_name.slice(0, 10)}
                                </span>
                              </div>
                            ) : (
                              <div className="file_wrapper">
                                {(media?.response_by === user?.id ||
                                  user?.role === "Admin") && (
                                  <div
                                    className="icon"
                                    onClick={() => deleteMediaTicket(media?.id)}
                                  >
                                    <MdClose />
                                  </div>
                                )}
                                <a
                                  href={media?.response_body?.file_url}
                                  target="_"
                                >
                                  {media?.response_body?.file_name.slice(0, 9)}
                                </a>
                              </div>
                            )}
                          </div>
                        )}
                      </Fragment>
                    ))}
                  </div>
                )}

              {shipperfiles === "recipient" &&
                shipmentMedia?.recipient?.length > 0 && (
                  <div className="disussionShipping__package_files">
                    {shipmentMedia?.recipient?.map((media) => (
                      <Fragment key={media?.id}>
                        {media?.response_body !== null && (
                          <div className="disussionShipping__package_file_holder">
                            {media?.response_type === "image" ? (
                              <div className="image_wrapper">
                                {(media?.response_by === user?.id ||
                                  user?.role === "Admin") && (
                                  <div
                                    className="icon"
                                    onClick={() => deleteMediaTicket(media?.id)}
                                  >
                                    <MdClose />
                                  </div>
                                )}
                                <img src={media?.response_body?.file_url} />
                                <span className="name">
                                  {media?.response_body?.file_name.slice(0, 10)}
                                </span>
                              </div>
                            ) : (
                              <div className="file_wrapper">
                                {(media?.response_by === user?.id ||
                                  user?.role === "Admin") && (
                                  <div
                                    className="icon"
                                    onClick={() => deleteMediaTicket(media?.id)}
                                  >
                                    <MdClose />
                                  </div>
                                )}
                                <a
                                  href={media?.response_body?.file_url}
                                  target="_"
                                >
                                  {media?.response_body?.file_name.slice(0, 9)}
                                </a>
                              </div>
                            )}
                          </div>
                        )}
                      </Fragment>
                    ))}
                  </div>
                )}

              {shipperfiles === "carrier" &&
                shipmentMedia?.carrier?.length > 0 && (
                  <div className="disussionShipping__package_files">
                    {shipmentMedia?.carrier?.map((media) => (
                      <Fragment key={media?.id}>
                        {media?.response_body !== null && (
                          <div className="disussionShipping__package_file_holder">
                            {media?.response_type === "image" ? (
                              <div className="image_wrapper">
                                {(media?.response_by === user?.id ||
                                  user?.role === "Admin") && (
                                  <div
                                    className="icon"
                                    onClick={() => deleteMediaTicket(media?.id)}
                                  >
                                    <MdClose />
                                  </div>
                                )}
                                <img src={media?.response_body?.file_url} />
                                <span className="name">
                                  {media?.response_body?.file_name.slice(0, 10)}
                                </span>
                              </div>
                            ) : (
                              <div className="file_wrapper">
                                {(media?.response_by === user?.id ||
                                  user?.role === "Admin") && (
                                  <div
                                    className="icon"
                                    onClick={() => deleteMediaTicket(media?.id)}
                                  >
                                    <MdClose />
                                  </div>
                                )}
                                <a
                                  href={media?.response_body?.file_url}
                                  target="_"
                                >
                                  {media?.response_body?.file_name.slice(0, 9)}
                                </a>
                              </div>
                            )}
                          </div>
                        )}
                      </Fragment>
                    ))}
                  </div>
                )}
              {shipperfiles === "admin" && shipmentMedia?.admin?.length > 0 && (
                <div className="disussionShipping__package_files">
                  {shipmentMedia?.admin?.map((media) => (
                    <Fragment key={media?.id}>
                      {media?.response_body !== null && (
                        <div className="disussionShipping__package_file_holder">
                          {media?.response_type === "image" ? (
                            <div className="image_wrapper">
                              {(media?.response_by === user?.id ||
                                user?.role === "Admin") && (
                                <div
                                  className="icon"
                                  onClick={() => deleteMediaTicket(media?.id)}
                                >
                                  <MdClose />
                                </div>
                              )}
                              <img src={media?.response_body?.file_url} />
                              <span className="name">
                                {media?.response_body?.file_name.slice(0, 10)}
                              </span>
                            </div>
                          ) : (
                            <div className="file_wrapper">
                              {(media?.response_by === user?.id ||
                                user?.role === "Admin") && (
                                <div
                                  className="icon"
                                  onClick={() => deleteMediaTicket(media?.id)}
                                >
                                  <MdClose />
                                </div>
                              )}
                              <a
                                href={media?.response_body?.file_url}
                                target="_"
                              >
                                {media?.response_body?.file_name.slice(0, 9)}
                              </a>
                            </div>
                          )}
                        </div>
                      )}
                    </Fragment>
                  ))}
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default DiscussionTickets;
